import Button from '@mui/lab/LoadingButton'
import { observer } from 'mobx-react-lite'
import { IosShareOutlined } from '@mui/icons-material'
import useStore from 'reusable/mobx-store-utils'
import ShareDocumentDialog from './ShareDocumentDialog'
import { useOrgGuardStore } from 'features/main/main-router/org-guard/OrgGuardStore'
import ShareDocumentStore from './ShareDocumentStore'
import useInitialMount from 'reusable/hooks/useInitialMount'
import { DocDto } from '@gap/backend/app-services/doc/models/DocDto'
import { DocShareDto } from '@gap/backend/app-services/doc-share/models/DocShareDto'

interface ShareDocumentProps {
   document: DocDto.outputDoc | DocDto.entity | DocShareDto.BusinessPlanDocument
   clientOrgId: string
}

export default observer(function ShareDocument(props: ShareDocumentProps) {
   const orgGuardStore = useOrgGuardStore()
   const shareDocumentStore = useStore((sp) => new ShareDocumentStore(sp), {
      document: props.document,
      clientOrgId: props.clientOrgId
   })

   useInitialMount(() => {
      if (orgGuardStore.org?.orgType === 'advisor') {
         shareDocumentStore.fetch()
      }
   })

   // Share dialog is for advisors only
   if (orgGuardStore.org?.orgType !== 'advisor') {
      return null
   }

   return <>
      {shareDocumentStore.shareDocumentDialogProps && (
         <ShareDocumentDialog {...shareDocumentStore.shareDocumentDialogProps} />
      )}
      <Button
         variant="contained"
         endIcon={<IosShareOutlined />}
         onClick={shareDocumentStore.modalState.open}
         loading={shareDocumentStore.loader.isLoading}
      >
         Share
      </Button>
   </>
})
